// Configuração de Auto-Refresh
// Centraliza intervalos de atualização automática de dados

export type RefreshType = 'critical' | 'moderate' | 'static';

const isRefreshEnabled = import.meta.env.VITE_REFRESH_ENABLED !== 'false';

const CRITICAL_INTERVAL = parseInt(
  import.meta.env.VITE_REFRESH_CRITICAL_INTERVAL ?? '10000',
  10
);
const MODERATE_INTERVAL = parseInt(
  import.meta.env.VITE_REFRESH_MODERATE_INTERVAL ?? '30000',
  10
);
const STATIC_INTERVAL = parseInt(
  import.meta.env.VITE_REFRESH_STATIC_INTERVAL ?? '300000',
  10
);

export function getRefreshInterval(type: RefreshType = 'moderate'): number | false {
  if (!isRefreshEnabled) return false;
  switch (type) {
    case 'critical':
      return CRITICAL_INTERVAL;
    case 'moderate':
      return MODERATE_INTERVAL;
    case 'static':
      return STATIC_INTERVAL;
    default:
      return MODERATE_INTERVAL;
  }
}

export interface RefreshQueryOptions {
  refetchInterval?: number | false;
  refetchIntervalInBackground?: boolean;
  [key: string]: unknown;
}

export function getRefreshConfig(
  type: RefreshType = 'moderate',
  options: Record<string, unknown> = {}
): RefreshQueryOptions {
  const interval = getRefreshInterval(type);
  if (!interval) {
    return { refetchInterval: false, ...options };
  }
  return {
    refetchInterval: interval,
    refetchIntervalInBackground: false,
    ...options,
  };
}

export const refreshConfig = {
  enabled: isRefreshEnabled,
  intervals: {
    critical: CRITICAL_INTERVAL,
    moderate: MODERATE_INTERVAL,
    static: STATIC_INTERVAL,
  },
  getRefreshInterval,
  getRefreshConfig,
};

export default refreshConfig;
